export const towardProfileLink = accountname => {
  return `/profile/${accountname}`;
};
